import { cn } from "../../../lib/utils";
import type { AuditEventType } from "../../../models/audit/auditEvent";
import { toneTextClass } from "./auditEventTone";
import { ICON_BY_EVENT_TYPE } from "./eventIcons";

interface AuditEventGlyphProps {
  eventType: AuditEventType;
  className?: string;
}

/**
 * The timeline node used on the drawer's rail: a small white disc with a
 * hairline border, so it reads as a node sitting *on* the connector rather
 * than a filled chip stitched between rows. The icon carries the event's
 * semantic tone; the disc itself stays neutral.
 */
export function AuditEventGlyph({
  eventType,
  className,
}: AuditEventGlyphProps) {
  const Icon = ICON_BY_EVENT_TYPE[eventType];

  return (
    <span
      className={cn(
        "flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full border bg-white",
        className,
      )}
    >
      <Icon className={cn("h-3 w-3", toneTextClass(eventType))} />
    </span>
  );
}
